import { Accordion, Text } from '@/ui'
import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { getTransactionCategoryNameSelector } from '../reports.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { TypographyStyles } from '@/styles'
import { LineItemExpanded } from './LineItemExpanded'

const LineItem = ({
  item,
  startDate,
  endDate,
  userIdForAdmin,
  isProfit,
  confirmed,
}: {
  item: {
    percentage?: string
    sum: number | string
    transactionCategoryId: number | null
  }
  startDate: string | undefined
  endDate: string | undefined
  userIdForAdmin: number | null
  isProfit?: boolean
  confirmed?: boolean
}) => {
  const categoryName = useReselector(
    getTransactionCategoryNameSelector,
    item.transactionCategoryId
  )

  return (
    <Accordion
      type="multiple"
      collapsible
      className={isProfit ? 'background-app' : 'bg-neutral-25'}
      variant="lineItem"
    >
      <Accordion.Item value={categoryName}>
        <Accordion.Trigger className="flex items-center justify-between p-2 m-0">
          <Text variant={TypographyStyles.H3} className="m-0">
            {categoryName}
          </Text>
          <Text
            variant={TypographyStyles.BODY_LG}
            className="flex-1 text-end m-0 pr-5"
          >
            <CurrencyFormatLabel value={item?.sum} />
          </Text>
        </Accordion.Trigger>
        <Accordion.Content>
          <LineItemExpanded
            item={item}
            startDate={startDate}
            endDate={endDate}
            userIdForAdmin={userIdForAdmin}
            open
            confirmed={confirmed}
          />
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  )
}

export { LineItem }
